module.exports = __webpack_public_path__ + "img/03.2d854df6.jpg";